<form #formControl="ngForm">
  <mat-dialog-content>
    <h3 mat-dialog-title>Are you sure?</h3>

    <mat-form-field color="accent">
      <input readonly matInput #input placeholder="Field" [(ngModel)]="field" name="field" />
    </mat-form-field>

    <!-- <mat-form-field color="accent">
      <input readonly matInput #input placeholder="Field Label" [(ngModel)]='fieldLabel' name="fieldLabel">
    </mat-form-field> -->
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="1" (click)="confirmDelete()">Delete</button>
    <button mat-button (click)="onNoClick()" tabindex="-1">Cancel</button>
  </mat-dialog-actions>
</form>
